import React, { FC, memo } from 'react';

import ProviderResult from './provider/provider-result';

import Layout from './components/layout';

const App: FC = memo(() => {
  return (
    <ProviderResult>
      <Layout />
    </ProviderResult>
  );
});

export default App;
